<template>
  <div
    :class="promoBannerClasses"
    :data-contentful-text="promoBanner.CmsBanner.Id"
    :style="promoBannerStyles"
  >
    {{ promoBanner.CmsBanner.Text }}
  </div>
</template>

<script>
export default {
  name: 'PromoBanner',
  props: {
    promoBanner: { type: Object, default: null, required: true },
    context: { type: String, default: null, required: false, validator () { return [null, 'cart', 'inline', 'inline-no-border'] } }
  },
  computed: {
    promoBannerClasses () {
      let classes = ['promo-banner']

      if (this.context === null) {
        return classes
      }

      if (this.context === 'cart') {
        classes.push('promo-banner--cart')
      }

      if (this.context === 'inline') {
        classes.push('promo-banner--inline')
      }

      if (this.context === 'inline-no-border') {
        classes.push('promo-banner--inline-no-border')
      }

      return classes
    },
    promoBannerStyles () {
      let styles = {}

      if (this.promoBanner.CmsBanner.TextColor) {
        styles.color = this.promoBanner.CmsBanner.TextColor
      }

      if (
        this.promoBanner.CmsBanner.BackgroundColor &&
        (this.context !== 'inline' && this.context !== 'inline-no-border')
      ) { // do not override background color with Contentful set one in 'inline' context
        styles.backgroundColor = this.promoBanner.CmsBanner.BackgroundColor
      }

      return styles
    }
  }
}
</script>

<style lang="scss" scoped>
.promo-banner {
  background-color: #f6f6f6;
  border-top: 1px solid #757575;
  border-bottom: 1px solid #757575;
  color: $grad-color-blue;
  font-size: 16px;
  font-weight: bold;
  padding: 11px 0;
  text-align: center;

  &--inline {
    background-color: transparent;
    border-top: 1px solid #757575;
    border-bottom: none;
    font-size: 20px;
    padding: 20px 0 0 0;
  }

  &--inline-no-border {
    background-color: transparent;
    border-top: none;
    border-bottom: none;
    font-size: 20px;
    padding: 0;
  }

  @media screen and (min-width: $screen-sm-min) {
    border-top: none;
    font-size: 20px;
    padding: 11px 0;

    &--cart {
      border-top: 1px solid #757575;
    }

    &--inline,
    &--inline-no-border {
      border: none;
      padding: 11px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/PromoBanner.vue